module.exports = __webpack_public_path__ + "static/media/Assets-07-Camden-Market-hero.aaf77abd.jpg";